"use client";

import { usePathname } from "next/navigation";
import DefaultSchema from "~/components/defaultSchema";
import { skipdefaultdata } from "~/data/custom-schema-path";

export default function SchemaWrapper() {
  const pathname = usePathname();
  const shouldSkipDefaultSchema = skipdefaultdata.includes(pathname) || pathname.startsWith('/blog/') || pathname.startsWith('/case-studies') || pathname.includes('/whitepaper/') || pathname.includes('/guide/');

  if (shouldSkipDefaultSchema) return null;

  return <DefaultSchema />;
}